<template>
  <Dashboard title="DemoViewerUpgradePage" no-padding="true">
    <!-- show screenshot and push to upgrade -->
    <div class="w-full h-full bg-gray-950 relative flex justify-center items-center">
      <img
        class="select-none w-full h-full object-cover"
        src="../assets/demo-viewer-preview.png"
      />
      <div
        class="w-full h-full bg-black/60 z-50 absolute items-center justify-center flex"
      >
        <UpgradeModal
          :title="$t('viewer.upgrade.title')"
          :firstBenefit="$t('viewer.upgrade.benefit_academy')"
          :secondBenefit="$t('viewer.upgrade.benefit_utility_hub')"
          primaryPromotionType="demo_review"
          video_url="https://www.youtube.com/embed/ncMKHXoSHkk?si=VBctYFRrgcLvdVKq"
        />
      </div>
    </div>
  </Dashboard>
</template>

<script setup>
import Dashboard from '../components/layouts/DashboardLayout.vue';
import UpgradeModal from '../components/UpgradeModal.vue';
</script>
